<template>
  <Portal v-show="show">
    <div ref="containerRef" class="cover-sheet" data-testid="cover-sheet">
      <Heading :level="1" class="cover-sheet__title">
        {{ title }}
      </Heading>
    </div>
  </Portal>
</template>

<script lang="ts">
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { Heading } from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import {
  addBodyScroll,
  toggleBodyScroll
} from '@/modules/common/helpers/browser';

@Component({
  name: 'CoverSheet',
  components: { Heading, Portal }
})
export default class CoverSheet extends Vue {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Boolean, default: false, required: true })
  private show!: boolean;

  @Ref()
  private containerRef!: HTMLDivElement;

  mounted() {
    this.containerRef.onanimationstart = this.onAnimationStart;
    this.containerRef.onanimationend = this.onAnimationEnd;
  }

  private onAnimationStart(event: AnimationEvent) {
    if (event.target !== this.containerRef) return;
    toggleBodyScroll();
  }

  private onAnimationEnd() {
    addBodyScroll();
    this.$emit('on-hide');
  }

  destroyed() {
    this.onAnimationEnd();
  }
}
</script>

<style lang="less" scoped>
@animation-total-time: 3s;
@animation-timing-function: cubic-bezier(0.42, 0, 0.04, 1);

.cover-sheet {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: @static-black;
  animation: overlay-animation @animation-total-time @animation-timing-function
    forwards;

  &__title {
    opacity: 0;
    color: @text-over-image;
    text-align: center;
    animation: title-animation 2.5s ease-in-out forwards;
    animation-delay: 250ms;
  }
}

@keyframes overlay-animation {
  from,
  75% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes title-animation {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }

  25%,
  75% {
    transform: translateY(0px);
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
